import * as React from 'react';
import styled from 'styled-components';
import { Header2Text } from '../Typography';
import type { FCWithChildren } from '../../../types/FCWithChildren';

export interface IFooterProps {
  /** Heading text. */
  title?: string | null;
  /** The children a Row of items  */
  areChildrenRow?: boolean;
}

const StyledFooter = styled.div`
  display: grid;
  background-color: ${(props) => props.theme.colors.defaultContentBackground};
  box-shadow: 0 -2px 2px 0 ${(props) => props.theme.colors.shadow};
  justify-items: center;
  grid-gap: ${(props) => props.theme.spacing.spacing5};
  margin-top: ${(props) => props.theme.spacing.spacing5};
  padding: ${(props) => props.theme.spacing.spacing5};
`;

const StyledChildWrapper = styled(StyledFooter)`
  align-items: center;
  display: flex;
  margin: auto;
  width: 100%;
`;

/**
 * The component at the bottom of the viewport.
 * Attached to {@link Layout}
 */
export const Footer: FCWithChildren<IFooterProps> = ({ areChildrenRow, title, children }) => {
  return (
    <StyledFooter>
      {title ? <Header2Text>{title}</Header2Text> : null}
      {children ? areChildrenRow ? <StyledChildWrapper>{children}</StyledChildWrapper> : children : null}
    </StyledFooter>
  );
};
